import React from 'react';
import Button from '../buttons/Button';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

function FormBack(props) {
  const { t } = useTranslation();
  return (
    <Button
      theme={['style-dark'].concat(props.theme ? props.theme : [])}
      url={props.url}
      onPress={props.onPress}
      title={props.title ? props.title : t('styleguide:back')}
      ariaLabel={props.ariaLabel ? props.ariaLabel : t('styleguide:link_to_previous')}
      iconType={'chevron-left'}
      iconPosition={'left'}
      className={classNames(['form__button-back'], props.className)}
      isDisabled={props.disabled}
    >
      {props.children || t('styleguide:forms.back')}
    </Button>
  );
}

export default FormBack;
